export interface BusinessDetailsRequest {
  vat_num?: string;
  billing_address?: string;
  size: BusinessSize;
}

export interface BusinessMinimal {
  name: string;
  status: BusinessStatus;
  card_kind: CardKind;
  beta: boolean;
}

export interface BusinessProfile extends BusinessDetailsRequest, BusinessMinimal {
  id: string;
  type: BusinessType;
  regnum: string;
  cert_file: string;
  created: string;
  updated: string;
  address: string;
  billing_address: string;
  subscription: string;
}

export enum BusinessSize {
  '0 - 10' = 10,
  '11 - 50' = 50,
  '51 - 250' = 250,
  '250+' = 251,
}

export enum BusinessStatus {
  New = 0,
  Error = 1,
  Rejected = 2,
  Reupload = 3,
  Verified = 10,
  DirectorError = 20,
  DirectorPartialApproval = 21,
  DirectorApproval = 22,
  PaymentPending = 40,
  Active = 100,
  PaymentMissed = 2000,
  DecommissionPending = 2090,
  Decommissioned = 2100,
}

export interface BankDetails {
  bank: string;
  branch_code: string;
  account_number: string;
  account_holder: string;
  account_type: AccountType;
}

export interface BankingDetailsRequest extends BankDetails {
  proof: string; // upload url
  proof_download_url: string;
}

export interface BankingDetails extends BankingDetailsRequest {
  id: number;
  status?: BankingStatus;
  business_id: number;
  created_by?: number;
  created_at?: Date;
  updated_at?: Date;
  approved_at?: Date;
  approver?: number;
  reviewer?: number;
  reviewed_at?: Date;
}

export enum BankingStatus {
  New = 0,
  Reviewed = 10,
  Approved = 20,
  Declined = 30,
  Removed = 40,
}

export enum AccountType {
  'Cheque' = 1,
  'Savings' = 2,
}

export enum CardKind {
  VIRTUAL = 1,
  PHYSICAL = 2,
}

export enum BusinessType {
  PUBLIC_COMPANY = 1,
  PRIVATE_COMPANY = 2,
  CLOSE_CORP = 3,
}
